import { Box, Divider, Link, useMediaQuery } from '@mui/material';
import React from 'react';
import BackedByYComb from 'core/assets/img/footer/backed-by-y-combinator.webp';
import { ReactComponent as Discord } from 'core/assets/svg/footer/discord.svg';
import { ReactComponent as Email } from 'core/assets/svg/footer/email.svg';
import { ReactComponent as Instagram } from 'core/assets/svg/footer/instagram.svg';
import { ReactComponent as Reddit } from 'core/assets/svg/footer/reddit.svg';
import { ReactComponent as Twitter } from 'core/assets/svg/footer/twitter.svg';
import BaseButton from 'core/components/button/BaseButton';
import BaseImage from 'core/components/image/BaseImage';
import Linked from 'core/components/link/Link';
import BaseTypography from 'core/components/typography/BaseTypography';
import {
	API,
	DISCORD,
	EMAIL,
	INSTAGRAM,
	PRIVACY_POLICY,
	REDDIT,
	TERMS_AND_CONDITIONS,
	TWITTER,
} from 'core/navigation/Routes';
import appTheme from 'core/layouts/ui-blocks/AppTheme';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import { footerStyles } from 'core/layouts/components/footer/FooterStyles';
import { ConditionalLayer } from 'core/layouts/ui-blocks/ReusableComponents';

function Footer() {
	const isMobile = useMediaQuery(appTheme.breakpoints.down('sm'));
	return (
		<Box id="footer-wrapper" sx={[footerStyles.footerWrapper]}>
			<Box sx={footerStyles.footer}>
				<Box id="backed-by-y-combinator" sx={footerStyles.backedByYComb}>
					<BaseImage src={BackedByYComb} alt="backed-by-Y-Combinator" />
				</Box>

				<Box id="links" sx={[reusableStyles.flexRow, footerStyles.links]}>
					<Box id="about-use" sx={[reusableStyles.flexRow, footerStyles.aboutUs]}>
						<BaseTypography variant="tooltip_regular" styles={footerStyles.footerText}>
							© Affogato.ai
						</BaseTypography>

						{!isMobile && <Box sx={footerStyles.divider} />}

						<BaseButton
							id="credits-button"
							styles={footerStyles.footerTextButton}
							href="https://rendernet.notion.site/RenderNet-Open-Source-Credits-f6f1727ad7ed4d83809568a361d908ce?pvs=4"
							target="_blank"
						>
							<BaseTypography
								component="span"
								variant="tooltip_regular"
								styles={footerStyles.footerText}
							>
								Credits
							</BaseTypography>
						</BaseButton>

						{!isMobile && <Box sx={footerStyles.divider} />}

						<BaseButton
							id="terms-and-conditions-button"
							styles={footerStyles.footerTextButton}
							href={TERMS_AND_CONDITIONS}
							target="_blank"
						>
							<BaseTypography variant="tooltip_regular" styles={footerStyles.footerText}>
								T&C
							</BaseTypography>
						</BaseButton>

						{!isMobile && <Box sx={footerStyles.divider} />}

						<BaseButton
							id="privacy-policy-button"
							styles={footerStyles.footerTextButton}
							href={PRIVACY_POLICY}
							target="_blank"
						>
							<BaseTypography variant="tooltip_regular" styles={footerStyles.footerText}>
								Privacy
							</BaseTypography>
						</BaseButton>

						<ConditionalLayer isShown={!window.electron}>
							{!isMobile && <Box sx={footerStyles.divider} />}
							<Linked to={`/${API}`} style={[footerStyles.footerTextButton]}>
								<BaseTypography variant="tooltip_regular" styles={footerStyles.footerText}>
									API
								</BaseTypography>
							</Linked>
						</ConditionalLayer>

						{!isMobile && <Box sx={footerStyles.divider} />}
					</Box>
					{isMobile && (
						<Divider
							orientation="horizontal"
							flexItem
							sx={{ borderColor: 'colors.dark1', width: '100%' }}
						/>
					)}
					<Box id="social-links" sx={[reusableStyles.flexRowWithGap(12)]}>
						<Link href={INSTAGRAM} target="_blank" sx={[footerStyles.footerTextButton]}>
							<Instagram />
						</Link>

						<Link href={TWITTER} target="_blank" sx={[footerStyles.footerTextButton]}>
							<Twitter />
						</Link>

						<Link href={DISCORD} target="_blank" sx={[footerStyles.footerTextButton]}>
							<Discord />
						</Link>

						<Link href={REDDIT} target="_blank" sx={[footerStyles.footerTextButton]}>
							<Reddit />
						</Link>

						<Link href={`mailto:${EMAIL}`} target="_blank" sx={[footerStyles.footerTextButton]}>
							<Email />
						</Link>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

Footer.propTypes = {};

export default Footer;
